// extracted by mini-css-extract-plugin
export default {"container":"fj_d","image":"fj_dy","title":"fj_c0","label":"fj_mw"};